__webpack_require__.p = "https://eagleeye-gamma.eu.aftx.amazonoperations.app/";